import React, { useState, useEffect } from 'react';
import qs from "qs";
import axios from "axios";
import { Modal, Paper } from '@material-ui/core';


const TextOptIn = () => {
    const [url, setUrl] = useState('');
    const [op, setOp] = useState("")
    const [smsMerchant, setSmsMerchant] = useState({});
    const [name, setName] = useState("");
    const [number, setNumber] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [optinStatus, setOptinStatus] = useState('');
    const [enableButton, setEnableButton] = useState(false);
    const [visitPrivacyPolicy, setVisitPrivacyPolicy] = useState(false);
    const [policyLink, setPolicyLink] = useState("")
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
      console.log(window.location.href.split("/")[3])
      setOp(window.location.href.split("/")[4])
      if (window.location.port) {
        setUrl(`${window.location.hostname}:${window.location.port}`)
      } else {
        setUrl(`${window.location.hostname.split(".")[0]}`)
      }
    }, [window.location])
    
    useEffect(() => {
      if (url?.length) {
        hydrateSMS();
      }
    }, [url])

    useEffect(() => {
      if (name.length && number.length === 14) {
        setEnableButton(true)
      } else {
        setEnableButton(false)
      }
    }, [name, number, isChecked])

    const hydrateSMS = async () => {
      const options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
        data: qs.stringify({
          method: "hydrateSMSEnable",
          op: op,
        }),
        url: `https://${url}.cpteller.com/lib/plivo.cfc`,
      };
      try {
  
        axios(options).then((response) => {
        setSmsMerchant(response.data.sms_merchant)
        })
      }
      catch (err) {
        console.log(err)
      }
    };

    const optInForTexts = async () => {
      const options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
        data: qs.stringify({
          method: "addNumberToStart",
          op: op,
          name: name,
          number: number,
          sms_agree: isChecked,
        }),
        url: `https://${url}.cpteller.com/lib/plivo.cfc`,
      };
      try {
  
        axios(options).then((response) => {
          setSuccessMessage(response.data.messageDetail)
          setOptinStatus(response.data.status)
          setIsChecked(false)

        })
      }
      catch (err) {
        console.log(err)
      }
    };

    const formatPhoneNumber = (str) => {
      //Filter only numbers from the input
      let cleaned = ('' + str).replace(/\D/g, '');
      
      //Check if the input is of correct length
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      };
    
      return null
    };


    const handlePhone = (value) => {
        //Filter only numbers from the input
        let cleaned = ('' + value).replace(/[a-zA-Z]|\D/g, '');
        setNumber(cleaned)
        //Check if the input is of correct length
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      
        if (match) {
          setNumber('(' + match[1] + ') ' + match[2] + '-' + match[3])
        };
      
    }

    const handleTerms = () => {
      const terms = <p><b>Convenient Payments, LLC, dba IntelliPay (“IntelliPay”) SMS/MMS Texting Terms of Use for Customers</b> <br/> <br />Welcome to Intellipay's SMS/MMS Texting Service. These Terms of Use ("Terms") outline the rules and guidelines for receiving and interacting with our SMS/MMS text messages ("Messages"). By receiving Messages from us, you agree to comply with these Terms. If you do not agree with these Terms, please refrain from interacting with our Messages. <br /><br /><b>Frequency of Messages:</b> You may receive Messages from Intellipay periodically. The frequency of Messages may vary depending on your interaction with our services, subscribed alerts, or other relevant events. <br /><br /><b>Content of Messages:</b> Messages may include important updates, account notifications, payment requests, and other relevant information related to Intellipay's services. We strive to provide valuable and relevant content in our Messages. Messages are not used strictly for marketing purposes. <br /><br /><b>Opt-Out Option:</b> If you no longer wish to receive messages from Intellipay, you can opt-out at any time by replying with the word "STOP" to any Message. You will be unsubscribed from receiving further Messages. <br /><br /><b>Resubscribe Option:</b> If you have previously unsubscribed but wish to start receiving Messages from Intellipay again, you can resubscribe by replying with the word "START" to any Message. <br /><br /><b>Help Option:</b> If you have questions about a Message, you can reply with the word "HELP" to receive further information about the message, such as who sent it, etc. For general help, you can also contact Intellipay support at support@intellipay.com or by calling (855) 872-6632. <br /><br /><b>Message and Data Rates:</b> Standard message and data rates may apply to Messages received from Intellipay, depending on your mobile service provider and plan. Please consult your mobile service provider for more information on applicable rates. <br /><br /><b>Privacy Policy:</b> Your privacy is important to us. We will only use your contact information for the purpose of sending Messages related to Intellipay's services and will not share or sell your information to third parties. For more information, please refer to our Privacy Policy. <br /><br /><b>Modification of Terms:</b> Intellipay reserves the right to modify or update these Terms at any time without prior notice. Changes to these Terms will be effective immediately upon posting. We encourage you to review these Terms periodically for any changes. <br /><br /><b>Contact Information:</b> If you have any questions or concerns about these Terms or our Messages, please contact us at support@intellipay.com or by calling (855) 872-6632.<br /><br />By receiving Messages from Intellipay, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree to these Terms, please refrain from interacting with our Messages.</p>


      setOptinStatus(3);
      setSuccessMessage(terms);
    }

    const handleClose = () => {
      setOptinStatus("");
      setName("");
      setNumber("");
    }

    const handlePrivacyPolicy = () => {
      setVisitPrivacyPolicy(true)
      setPolicyLink("https://intellipay.com/privacy-policy/");
    }

    const handleCaliforniaPolicy = () => {
      setVisitPrivacyPolicy(true)
      setPolicyLink("https://intellipay.com/privacy-statement-california/")
    }



    return ( 
      <div className="page-wrapper">
        <div className="opt-in-wrapper">
              <img
          src={smsMerchant.merchant_logo_path}
          alt={"merchant-logo"}
        />
        <div className="form">
          <h1 className='title'> SMS Opt-In Form</h1>
            <div className="field">
            <p>Name</p>
            <input type="text" placeholder='Name' onChange={(e) => setName(e.target.value)} value={name}/>
            </div>
            <div className="field">
            <p>Mobile Phone</p>
            <input type="text" placeholder='Mobile Phone' onChange={(e) => handlePhone(e.target.value)} value={number} maxLength={10} />
            </div>
            <div className="terms-confirm">
              <div className='checkbox-wrapper'>
              <input type="checkbox" onChange={() => setIsChecked(!isChecked)} checked={isChecked}/>
              <p className='checkbox-terms'>{`By checking this box, you give consent to Intellipay to send SMS related to your account${smsMerchant.merchant_name !== "Intellipay" ? ` on behalf of ${smsMerchant.merchant_name}` : ""}${smsMerchant.merchant_name?.charAt(smsMerchant.merchant_name.length - 1) === "." ? "" : "."}`}</p>
              </div>
              <p className='checkbox-terms indented'>{`You may receive up to 1 or more messages per week depending on your subscribed alerts and billing frequency. For HELP, text us at ${formatPhoneNumber(smsMerchant.merchant_sms_number)} or call us directly at ${formatPhoneNumber(smsMerchant.merchant_support_phone)}. To unsubscribe, text STOP. Standard messaging and data rates apply.`}</p>
              <p className="checkbox-terms indented">{smsMerchant.merchant_name !== "Intellipay" ? "You can also reach Intellipay Support at (855) 872-6632 or support@intellipay.com." : ""}</p>
              <p className='checkbox-terms indented'>By clicking Opt In, you agree to our Terms of Use and Privacy Policies linked below.</p>
            </div>
            <button disabled={!enableButton} onClick={optInForTexts}>Opt In</button>
        </div>
        <div className="terms">
            <div className="extra-info">
              <p onClick={handleTerms}>Terms of Use</p><p style={{paddingLeft: "30px",}} onClick={handlePrivacyPolicy}>Privacy Policy</p> <p style={{paddingLeft: "30px",}} onClick={handleCaliforniaPolicy}>Privacy Statement-California</p>
            </div>
        </div>
        </div>
        <Modal
          open={visitPrivacyPolicy}
          onClose={() => setVisitPrivacyPolicy(false)}
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            width: '23vw',
            top: '25vh',
            left: '38.5vw',
            height: 'fit-content',
            }}
        >
          <div className="privacy-policy-message">
            <p>This privacy policy will open in another tab.</p>
            <div className="buttons">
            <button onClick={() => setVisitPrivacyPolicy(false)}>Cancel</button>
            <a href={policyLink} target='_blank'><button className='confirm' onClick={() => setVisitPrivacyPolicy(false)}>Confirm</button></a>
            </div>
          </div>
          </Modal>
        <Modal
          open={optinStatus}
          onClose={() => setOptinStatus("")}
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            width: '23vw',
            top: '25vh',
            left: '38.5vw',
            height: 'fit-content',
            }}
        >
            <div className='optin-message'>
            <p className='close' onClick={handleClose}>X</p>
            <div className="text-wrapper">
            <h1 className={optinStatus === 1 ? "success" : "error"}>{optinStatus === 1 ? "Success!" : optinStatus === 0 ? "Failed." : ""}</h1>
            <p>{successMessage}</p>
            </div>
            </div>
        </Modal>
      </div>
     );
}
 
export default TextOptIn;